import { createFileRoute } from '@tanstack/react-router';

import { EditorialTeamCreate } from '@/module/Author/EditorialTeam/EditorialTeamCreate';

export const Route = createFileRoute('/_auth/author/_author/editorial-team/_editorialTeam/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <EditorialTeamCreate />;
}
